<script lang="ts">
  import { page } from '$app/stores';
  import IconChevronLeft from '~icons/tabler/chevron-left';
  import IconChevronRight from '~icons/tabler/chevron-right';

  export let nextPage: boolean;
  export let className: string = '';

  $: path = $page.url.pathname;
  $: pageParam = $page.url.searchParams.get('page');
  $: currentPage = pageParam ? parseInt(pageParam, 10) : 1;
  $: isFirstPage = currentPage === 1;
  $: startIndex = currentPage > 2 ? currentPage - 2 : 0;
  // prettier-ignore
  $: visible = currentPage > 1
    ? nextPage ? 3 : 2
    : nextPage ? 2 : 1;

  $: getPath = (page: number) => {
    const params = new URLSearchParams($page.url.search);

    if (page === 1) {
      params.delete('page');
    } else {
      params.set('page', page.toString());
    }

    const paramsStr = params.toString();

    if (paramsStr.length > 0) {
      return `${path}?${params}`;
    }

    return `${path}`;
  };
</script>

<nav aria-label="Pages navigation" class={`d-flex align-items-center gap-4 ${className}`}>
  <ul class="pagination mb-0">
    {#if currentPage > 2}
      <li class="page-item">
        <a rel="external" class="page-link h-100 d-flex align-items-center rounded me-2" href={getPath(1)}>
          First page
        </a>
      </li>
    {/if}

    <li class="page-item">
      <a
        class="page-link h-100 d-flex align-items-center"
        href={isFirstPage ? null : getPath(currentPage - 1)}
        class:disabled={isFirstPage}
        aria-label="Previous"
        rel="external"
      >
        <IconChevronLeft style="font-size: 0.75em" />
      </a>
    </li>

    {#each { length: visible } as _, i}
      {@const p = startIndex + i + 1}
      <li class="page-item">
        {#if p === currentPage}
          <span class="page-link h-100 d-flex align-items-center active">{p}</span>
        {:else}
          <a
            rel="external"
            class="page-link h-100 d-flex align-items-center"
            class:active={p === currentPage}
            href={getPath(p)}>{p}</a
          >
        {/if}
      </li>
    {/each}

    <li class="page-item">
      <a
        class="page-link h-100 d-flex align-items-center"
        class:disabled={!nextPage}
        href={getPath(currentPage + 1)}
        aria-label="Next"
        rel="external"
      >
        <IconChevronRight style="font-size: 0.75em" />
      </a>
    </li>
  </ul>
</nav>
